import React, { useMemo } from 'react'
import { AppLinks } from '../../../shared/legacy/app-links'
import { Card } from '../../../shared/card/card'
import { SelfRegisterCard } from './self-register-card'
import { EXISTING_ACCOUNT_MESSAGE } from '../../trade-show-register/trade-show-result'

export const SelfRegisterResult = ({ apFormSelfRegister, onDismiss }) => {
  let textColor = useMemo(() => apFormSelfRegister.form.colorText || 'black', [apFormSelfRegister.form])

  let colorButtonPrimaryBackground = useMemo(() => apFormSelfRegister.form.colorButtonPrimaryBackground || '', [apFormSelfRegister.form])
  let colorButtonPrimaryText = useMemo(() => apFormSelfRegister.form.colorButtonPrimaryText || '', [apFormSelfRegister.form])

  return (
    <React.Fragment>
      <div className="row">
        <div className="mx-auto col-12 col-lg-10">
          <SelfRegisterCard apFormSelfRegister={apFormSelfRegister}>
            {apFormSelfRegister.form.existingAccount
              ? <React.Fragment>
                  <h4 className="p-1">Welcome back</h4>
                  <div className="p-1">
                    {EXISTING_ACCOUNT_MESSAGE}
                  </div>
                  <div className="p-1">
                    <strong>
                      {apFormSelfRegister.form.email}
                    </strong>
                  </div>
                </React.Fragment>
              : <React.Fragment>
                  <h4 className="p-1">Account Created</h4>
                  <div className="p-1">
                    Use the pin below to sign up into the experience. This pin will expire in {apFormSelfRegister.form.pinExpire}, look for an invite email for full
                    registration
                  </div>
                  <div className="p-1">
                    <table className="table table-sm table-borderless">
                      <tbody>
                        <tr>
                          <td className="text-end" style={{ color: textColor }}>
                            Email
                          </td>
                          <td>
                            <strong>
                              {apFormSelfRegister.form.email}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-end" style={{ color: textColor }}>
                            Pin
                          </td>
                          <td>
                            <strong>
                              {apFormSelfRegister.form.pin}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>}
            <SelfRegisterPrimaryButton text="dismiss" backgroundColor={colorButtonPrimaryBackground} textColor={colorButtonPrimaryText} onClick={onDismiss} />
          </SelfRegisterCard>
        </div>
      </div>

      <div className="row">
        <div className="mx-auto col-12 col-lg-10">
          <Card className="mt-3" title="download links">
            <AppLinks />
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

const SelfRegisterPrimaryButton = ({ text, backgroundColor, textColor, onClick }) => {
  return (
    <button className={backgroundColor ? 'btn border' : 'btn btn-primary'} style={{ color: textColor, backgroundColor: backgroundColor }} onClick={onClick}>
      {text}
    </button>
  )
}
